module.exports = __webpack_public_path__ + "img/Left-arrow.924f600f.svg";